import SearchMainPageView from 'src/pages/SearchPage/SearchMainPage/view'
import { QueryClient } from '@tanstack/react-query'
import {
  searchPopularCouponQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { PopularCouponListSpace } from 'src/types/api'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import React, { MouseEvent } from 'react'
import usePageNav from 'src/hooks/usePageNav.hook'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'

export interface SearchMainPageProps {
  PopularCoupon?: PopularCouponListSpace.PopularCouponItemType[]
  alwaysCouponDetailPageNav: (couponNumber: string, couponIdx: number) => void
  searchResultPageNavHandler: (event: MouseEvent<HTMLButtonElement>) => void
  isPopularCoupon: boolean
  isRecentHistory: boolean
}
export const searchMainPageLoader = (queryClient: QueryClient) => async () => {
  return Promise.allSettled([await queryClient.ensureQueryData(searchPopularCouponQueryOption())])
}
const SearchMainPage = () => {
  const { searchResultPageNav, alwaysCouponDetailPageNav } = usePageNav()
  const { data: popularQueryData, isLoading: isPopularDataLoading } =
    useCustomQuery<PopularCouponListSpace.Response>(searchPopularCouponQueryOption())
  const [recentHistory, setRecentHistory] = useLocalStorage<string[]>('recent_search_history', [])

  const { PopularCoupon } = popularQueryData?.Body as PopularCouponListSpace.Response
  const isPopularCoupon = PopularCoupon?.length !== 0
  const isRecentHistory = recentHistory ? recentHistory?.length !== 0 : false

  const searchResultPageNavHandler = (event: MouseEvent<HTMLButtonElement>) => {
    const buttonText = event.currentTarget.textContent as string
    const filteredArray = recentHistory.filter((element) => element !== buttonText)
    setRecentHistory?.([buttonText]?.concat(filteredArray))
    searchResultPageNav(buttonText as string)
  }

  const props: SearchMainPageProps = {
    PopularCoupon,
    searchResultPageNavHandler,
    isPopularCoupon,
    isRecentHistory,
    alwaysCouponDetailPageNav,
  }

  return (
    <React.Fragment>
      <RenderIf when={isPopularDataLoading}>
        <Loading.Default />
      </RenderIf>
      <SearchMainPageView {...props} />
    </React.Fragment>
  )
}
export default SearchMainPage
